/**
 * marquee-craft-strip.js — Phase 5A.2
 *
 * Doubles the inner track HTML for a seamless CSS-driven loop.
 * Respects prefers-reduced-motion by leaving the track static.
 */

const TRACK_SELECTOR = '[data-marquee-track]';
const ROOT_SELECTOR = '[data-marquee]';

function initMarquee(root) {
  if (root.dataset.marqueeInit === 'true') return;
  root.dataset.marqueeInit = 'true';

  const track = root.querySelector(TRACK_SELECTOR);
  if (!track) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.dataset.marqueeReducedMotion = 'true';
    return;
  }

  // Duplicate the track contents once for seamless loop.
  track.insertAdjacentHTML('beforeend', track.innerHTML);
}

document.querySelectorAll(ROOT_SELECTOR).forEach(initMarquee);

// Re-init on Shopify section reload (theme editor):
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(ROOT_SELECTOR).forEach(initMarquee);
});
